const urls = {
    MATERIAL_BALANCE_LOT_MANAGEMENT: 'material-balance-lot-management',
    MATERIAL_BALANCE_TEMPLATE_LOT: 'material-balance-template-lot',
    MATERIAL_BALANCE_LOT_MANAGEMENT_CLONE: 'material-balance-lot-management-clone',
    MATERIAL_BALANCE_PRODUCT_STOCK: 'material-balance-product-stock',
    MATERIAL_BALANCE_PRODUCT_STOCK_COPY_MANUAL_FROM: 'material-balance-product-stock-copy-manual-from',
    MATERIAL_BALANCE_COMPANY_SECTION: 'material-balance-company-section',
    MATERIAL_BALANCE_PROCESSING_PRODUCTION: 'material-balance-processing-production',
    MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP: 'material-balance-processing-production-temp',
    MATERIAL_BALANCE_PROCESSING_PRODUCTION_PROPOSED_TEMP_HEADER:'material-balance-processing-production-temp-proposed-temp-header',
    MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP_IMPORT_FROM_FILE: 'material-balance-processing-production-temp-import-from-file',
    MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP_DETAIL: 'material-balance-processing-production-temp-detail',
    MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP_CANCEL: 'material-balance-processing-production-temp-cancel',
    MATERIAL_BALANCE_PROCESSING_PRODUCTION_CONFIRM_IMPORT: 'material-balance-processing-production-confirm-import',
    MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP_INCLUDE_DETAIL: 'material-balance-processing-production-temp-include-detail',
    MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP_EXCLUDE_DETAIL: 'material-balance-processing-production-temp-exclude-detail',
    MATERIAL_BALANCE_SHEET: 'material-balance-sheet',
    MATERIAL_BALANCE_SHEET_DETAIL: 'material-balance-sheet-detail',
    MATERIAL_BALANCE_SHEET_CALCULATE_REFINERY_BALANCE: 'material-balance-sheet-calculate-refinery-balance',
    MATERIAL_BALANCE_SHEET_CALCULATE_COMPANY_BALANCE: 'material-balance-sheet-calculate-company-balance',
    MATERIAL_BALANCE_SHEET_PUBLISH: 'material-balance-sheet-publish',
    MATERIAL_BALANCE_SHEET_PROGRESSIVE_BALANCE: 'material-balance-sheet-progressive-balance',
    MATERIAL_BALANCE_SHEET_DETAIL_PROGRESSIVE_BALANCE: 'material-balance-sheet-detail-progressive-balance',
    MATERIAL_BALANCE_PROCESSING_PRODUCTION_EXPORT: 'material-balance-processing-production-export-aggregate-processing-production',
    MATERIAL_BALANCE_LOT_MANAGEMENT_EXPORT_STOCK: 'material-balance-lot-management-export-stock',
    MATERIAL_BALANCE_LOT_MANAGEMENT_EXPORT_AGGREGATE_MOVEMENTS: 'material-balance-lot-management-export-aggregate-movements',
    MATERIAL_BALANCE_EXPORT_AGGREGATE_BALANCE: 'material-balance-sheet-export-aggregate-balance',
    MATERIAL_BALANCE_LOT_MANAGEMENT_IMPORT_FROM_LOADING: 'material-balance-lot-management-import-from-loading',
    MATERIAL_BALANCE_PRODUCT_STOCK_IMPORT_FROM_BMM: 'material-balance-product-stock-import-from-bmm',
    MATERIAL_BALANCE_PRODUCT_STOCK_IMPORT_FROM_IGCC: 'material-balance-product-stock-import-from-igcc',
    COMPULSORY_STOCKS: 'material-balance/compulsory-stock',
    COMPULSORY_STOCKS_LOAD_IMPORT: 'material-balance/compulsory-stock/import',
    COMPULSORY_STOCKS_MINISTERIAL_FORMAT: 'material-balance/compulsory-stock/ministerialformat',
    COMPULSORY_STOCKS_MINISTERIAL_FORMAT_EXPORT: 'material-balance/compulsory-stock/ministerialformat/export/excel',
    PERIODIC_MOVEMENT_BY_SEA_REPORT: 'material-balance-periodic-movement-by-sea-report',
    PERIODIC_MOVEMENT_BY_SEA_REPORT_EXCEL: 'material-balance-periodic-movement-by-sea-report-excel',
    DAILY_COMPULSORY_STOCKS: 'material-balance/daily-compulsory-stock',
    DAILY_COMPULSORY_STOCKS_EXPORT: 'material-balance/daily-compulsory-stock-export',
    DAILY_COMPULSORY_STOCKS_LOAD_IMPORT: 'material-balance/daily-compulsory-stock/import',
    DAILY_COMPULSORY_STOCKS_MINISTERIAL_FORMAT: 'material-balance/daily-compulsory-stock/ministerialformat',
    DAILY_COMPULSORY_STOCKS_MINISTERIAL_FORMAT_EXPORT: 'material-balance/daily-compulsory-stock/ministerialformat/export/excel',
}

import genericService from '../genericService';

export default {
    async updateLotManagement(body, callback){
        await genericService.put(urls.MATERIAL_BALANCE_LOT_MANAGEMENT, body).then(callback);
    },
    async addLotManagement(body, callback){
        await genericService.post(urls.MATERIAL_BALANCE_LOT_MANAGEMENT, body).then(callback);
    },
    async getLotTemplate(body, callback){
        await genericService.get(urls.MATERIAL_BALANCE_TEMPLATE_LOT, body).then(callback);
    },
    async cloneLotManagement(body, callback){
        await genericService.post(urls.MATERIAL_BALANCE_LOT_MANAGEMENT_CLONE, body).then(callback);
    },
    async getProductStock(body, callback){
        await genericService.get(urls.MATERIAL_BALANCE_PRODUCT_STOCK, body).then(callback);
    },
    async addProductStock(body, callback){
        await genericService.post(urls.MATERIAL_BALANCE_PRODUCT_STOCK, body).then(callback);
    },
    async updateProductStock(body, callback){
        await genericService.put(urls.MATERIAL_BALANCE_PRODUCT_STOCK, body).then(callback);
    },
    async copyFromStockDate(body, callback){
        await genericService.post(urls.MATERIAL_BALANCE_PRODUCT_STOCK_COPY_MANUAL_FROM, body).then(callback);
    },
    async getCompanySection(body, callback){
        await genericService.get(urls.MATERIAL_BALANCE_COMPANY_SECTION, body).then(callback);
    },
    async getCompanySectionById(id, callback){
        await genericService.getItem(urls.MATERIAL_BALANCE_COMPANY_SECTION, id).then(callback);
    },
    async getProcessingProduction(body, callback){
        await genericService.get(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION, body).then(callback);
    },
    async getProcessingProductionById(id, callback){
        await genericService.getItem(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION, id).then(callback);
    },
    async getProcessingProductionTemp(body, callback){
        await genericService.get(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP, body).then(callback);
    },
    async getProcessingProductionTempDetails(id, callback){
        await genericService.getItem(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP, id).then(callback);
    },
    async getProcessingProductionProposedTempHeader(body, callback){
        await genericService.get(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION_PROPOSED_TEMP_HEADER, body).then(callback);
    },
    async importFromFile(formData, callback){
        await genericService.post(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP_IMPORT_FROM_FILE, formData).then(callback);
    },
    async updateTempRecord(body, callback){
        await genericService.put(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP_DETAIL, body).then(callback);
    },
    async deleteTempImport(id, callback){
        await genericService.delete(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP_CANCEL, id).then(callback);
    },
    async confirmImport(body, callback){
        await genericService.post(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION_CONFIRM_IMPORT, body).then(callback);
    },
    async excludeDetail(body, callback){
        await genericService.put(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP_EXCLUDE_DETAIL, body).then(callback);
    },
    async includeDetail(body, callback){
        await genericService.put(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION_TEMP_INCLUDE_DETAIL, body).then(callback);
    },
    async getMonthlyMaterialBalance(body, callback){
        await genericService.get(urls.MATERIAL_BALANCE_SHEET, body).then(callback);
    },
    async getMonthlyMaterialBalanceDetail(body, callback){
        await genericService.get(urls.MATERIAL_BALANCE_SHEET_DETAIL, body).then(callback);
    },
    async calculateRefineryBalance(body, callback){
        await genericService.post(urls.MATERIAL_BALANCE_SHEET_CALCULATE_REFINERY_BALANCE, body).then(callback);
    },
    async calculateCompanyBalance(body, callback){
        await genericService.post(urls.MATERIAL_BALANCE_SHEET_CALCULATE_COMPANY_BALANCE, body).then(callback);
    },
    async publishBalance(body, callback){
        await genericService.post(urls.MATERIAL_BALANCE_SHEET_PUBLISH, body).then(callback);
    },
    async importFromLoadingLotManagement(body, callback){
        await genericService.post(urls.MATERIAL_BALANCE_LOT_MANAGEMENT_IMPORT_FROM_LOADING, body).then(callback);
    },
    async importFromIgccProductStock(body, callback){
        await genericService.post(urls.MATERIAL_BALANCE_PRODUCT_STOCK_IMPORT_FROM_IGCC, body).then(callback);
    },
    async importFromBMMProductStock(body, callback){
        await genericService.post(urls.MATERIAL_BALANCE_PRODUCT_STOCK_IMPORT_FROM_BMM, body).then(callback);
    },
    async getProgressiveMaterialBalance(body, callback){
        await genericService.get(urls.MATERIAL_BALANCE_SHEET_PROGRESSIVE_BALANCE, body).then(callback);
    },
    async getProgressiveMaterialBalanceDetail(body, callback){
        await genericService.get(urls.MATERIAL_BALANCE_SHEET_DETAIL_PROGRESSIVE_BALANCE, body).then(callback);
    },
    async exportMaterialBalanceProcessingProduction(body, callback){
        await genericService.dowloadFile(urls.MATERIAL_BALANCE_PROCESSING_PRODUCTION_EXPORT, body).then(callback);
    },
    async exportMaterialBalanceLotManagementStock(body, callback){
        await genericService.dowloadFile(urls.MATERIAL_BALANCE_LOT_MANAGEMENT_EXPORT_STOCK, body).then(callback);
    },
    async exportMaterialBalanceLotManagementAggregateMovements(body, callback){
        await genericService.dowloadFile(urls.MATERIAL_BALANCE_LOT_MANAGEMENT_EXPORT_AGGREGATE_MOVEMENTS, body).then(callback);
    },
    async exportMaterialBalanceAggregateBalance(body, callback){
        await genericService.dowloadFile(urls.MATERIAL_BALANCE_EXPORT_AGGREGATE_BALANCE, body).then(callback);
    },

    async getCompulsoryStocks(body, callback){
        await genericService.get(urls.COMPULSORY_STOCKS, body).then(callback);
    },
    async createCompulsoryStock(body, callback){
        await genericService.post(urls.COMPULSORY_STOCKS, body).then(callback);
    },
    async updateCompulsoryStock(body, callback){
        await genericService.put(urls.COMPULSORY_STOCKS, body).then(callback);
    },
    async deleteCompulsoryStock(id, callback){
        await genericService.delete(urls.COMPULSORY_STOCKS, id).then(callback);
    },

    async getCompulsoryStocksToImport(body, callback){
        await genericService.get(urls.COMPULSORY_STOCKS_LOAD_IMPORT, body).then(callback);
    },
    async confirmCompulsoryStockToImport(body, callback){
        await genericService.post(urls.COMPULSORY_STOCKS_LOAD_IMPORT + '?referenceDate=' + body.referenceDate, body).then(callback);
    },

    //COMPULSORY_STOCKS_MINISTERIAL_FORMAT
    async getCompulsoryStocksMinisterialFormat(body, callback){
        await genericService.get(urls.COMPULSORY_STOCKS_MINISTERIAL_FORMAT, body).then(callback);
    },
    async exportCompulsoryStocksMinisterialFormat(body, callback){
        await genericService.dowloadFile(urls.COMPULSORY_STOCKS_MINISTERIAL_FORMAT_EXPORT, body).then(callback);
    },
    async exportPeriodicMovementBySeaExcel(body, callback){
        await genericService.dowloadFile(urls.PERIODIC_MOVEMENT_BY_SEA_REPORT_EXCEL, body).then(callback);
    },
    async getDailyCompulsoryStocks(body, callback){
        await genericService.get(urls.DAILY_COMPULSORY_STOCKS, body).then(callback);
    },
    async createDailyCompulsoryStock(body, callback){
        await genericService.post(urls.DAILY_COMPULSORY_STOCKS, body).then(callback);
    },
    async updateDailyCompulsoryStock(body, callback){
        await genericService.put(urls.DAILY_COMPULSORY_STOCKS, body).then(callback);
    },
    async deleteDailyCompulsoryStock(id, callback){
        await genericService.delete(urls.DAILY_COMPULSORY_STOCKS, id).then(callback);
    },

    async getDailyCompulsoryStocksToImport(body, callback){
        await genericService.get(urls.DAILY_COMPULSORY_STOCKS_LOAD_IMPORT, body).then(callback);
    },
    async confirmDailyCompulsoryStockToImport(body, callback){
        await genericService.post(urls.DAILY_COMPULSORY_STOCKS_LOAD_IMPORT + '?referenceDate=' + body.referenceDate, body).then(callback);
    },
     async exportDailyCompulsoryStocks(body, callback){
        await genericService.dowloadFile(urls.DAILY_COMPULSORY_STOCKS_EXPORT, body).then(callback);
    },

    //DAILY-COMPULSORY_STOCKS_MINISTERIAL_FORMAT
    async getDailyCompulsoryStocksMinisterialFormat(body, callback){
        await genericService.get(urls.DAILY_COMPULSORY_STOCKS_MINISTERIAL_FORMAT, body).then(callback);
    },
    async exportDailyCompulsoryStocksMinisterialFormat(body, callback){
        await genericService.dowloadFile(urls.DAILY_COMPULSORY_STOCKS_MINISTERIAL_FORMAT_EXPORT, body).then(callback);
    }
}